<p-dialog
    [id]="id()"
    [class]="'custom-modal ' + modalType()"
    role="dialog"
    aria-modal="true"
    [style]="{ width: modalSizeComputed() }"
    [draggable]="false"
    [modal]="true"
    [closable]="closable()"
    [focusOnShow]="focusOnShow()"
    [resizable]="false"
    [closeOnEscape]="true"
    [dismissableMask]="closeInClickOutside()"
    [(visible)]="visible"
    (onShow)="onDialogShow()"
    (visibleChange)="closeModal()">
    <ng-template pTemplate="header">
        @if (title()) {
            <h1 class="modal-title">{{ title() | translate }}</h1>
        } @else {
            <div class="modal-title">
                <ng-content select="[header]"></ng-content>
            </div>
        }
    </ng-template>

    <ng-content select="[body]"></ng-content>

    <ng-template pTemplate="footer">
        <ng-content select="[footer]"></ng-content>
    </ng-template>
</p-dialog>
